import * as enumData from '@/data'
import { getVuex } from './index'

const factory = (value, source) => {
  if (value === undefined) {
    return value
  }
  let obj = source.find(c => `${c.value === undefined ? c.Value : c.value}`.trim() === `${value}`.trim())
  return (obj && (obj.label || obj.Label)) || value
}

const getCompanies = () => {
  let customer = getVuex('customer')
  let loginUser = customer && customer['CUSTOMER_LOGINCUSTOMER']
  let commonData = []
  if (loginUser && loginUser.data) {
    let key = `${loginUser.data.CustomerId}_/jobNo/getSmallSuppliers?filterWithJob=1_all`
    let key2 = `${loginUser.data.CustomerId}_/jobNo/getSmallSuppliers?filterWithJob=0&partnerLevel=-1`
    let key1 = `${loginUser.data.CustomerId}_jobNo/getSmallSuppliers?filterWithJob=1`
    let keyFeiche = 'GETSMALLSUPPLIERS_FEICHE'
    const _data = getVuex('commonData')
    commonData = _data[key] || _data[key2] || _data[key1] || _data[keyFeiche]
  }
  return commonData
}

let methods = {}
const getData = (value) => {
  Object.keys(value).forEach(key => {
    let type = value[key] instanceof Array

    if (type) {
      methods[key] = (val) => {
        if (key === 'companyArray') {
          const company = getCompanies() || []
          const _data = [...value[key], ...company]
          return factory(val, _data)
        }
        return factory(val, value[key])
      }
    } else {
      getData(value[key])
    }
  })
}

getData(enumData)
console.log('🚀 ~ file: data.js:48 ~ enumData:', enumData.default.finance)
export const data = {...methods}

export const getBalanceMode = () => {
  const finance = enumData.default.finance
  const customer = getVuex('customer')
  const result = finance.balanceMode
  const loginUser = customer && customer['CUSTOMER_LOGINCUSTOMER']
  if (loginUser && loginUser.data) {
    const PartnerId = loginUser.data.PartnerId
    if (PartnerId === 20054) {
      return result
    }
  }
  return result.filter(item => !item.hidden)
}



// WEBPACK FOOTER //
// ./src/utils/data.js